module.exports = __webpack_public_path__ + "static/media/auto_icon.35628f30.svg";